import React, { ReactElement } from "react"

import "./block.css"

interface BadBlockContentProps {
  content: string
}

interface BlockProps extends React.HTMLAttributes<HTMLDivElement> {
  content: ReactElement
}

export const Block = ({ content, children, className, ...restProps }: BlockProps) =>
  <div className={`${CSS.block} ${className || ""}`} {...restProps}>
    <BlockContent>
      {content}
    </BlockContent>

    {children && <BlockChildren>
      {React.Children.map(children, child => <ChildBlock>{child}</ChildBlock>)}
    </BlockChildren>
    }
  </div>

export const BlockContent = (props: React.HTMLAttributes<HTMLSpanElement>) =>
  <span className={CSS.blockContent} {...props}>
    {props.children}
  </span>

export const BlockChildren = (props: React.HTMLAttributes<HTMLUListElement>) =>
  <ul className={CSS.blockChildren} {...props}>
    {props.children}
  </ul>

export const ChildBlock = (props: React.HTMLAttributes<HTMLLIElement>) =>
  <li className={CSS.childBlock} {...props}>
    {props.children}
  </li>

export const BlockContentFailedParsing = ({ content }: BadBlockContentProps) =>
  <span className={CSS.blockFailedParsing}
        title={"This block failed to parse and is displayed as plaintext"}>
  {`${content}`}
</span>


const CSS = {
  block: "block",
  childBlock: "child-block",
  blockBody: "block-body",
  blockContent: "block-content",
  blockChildren: "block-children",
  blockFailedParsing: "block-failed-parsing",
}
